// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf892149","453":"bc3a0fb0","455":"f8439d17","977":"7132e56f"}[chunkId] + ".chunk.js";
};